export const products = {
  antibiotic: [
    { name: "Avilamycin Premix", nameZh: "阿维拉霉素预混剂", specs: "10%, 20% | CVP | 25kg/bag" },
    { name: "Nosiheptide Premix", nameZh: "那西肽预混剂", specs: "0.5%, 1%, 2%, 4% | CVP | 25kg/bag" },
    { name: "Enramycin Premix", nameZh: "恩拉霉素预混剂", specs: "4%, 8%, 10% | CVP | 25kg/bag" },
    { name: "Kitasamycin Premix", nameZh: "北里霉素预混剂", specs: "10%, 50% | CVP | 25kg/bag" },
    { name: "Lincomycin Premix", nameZh: "林可霉素预混剂", specs: "4.4%, 11% | CVP | 25kg/bag" },
    { name: "Quinocetone Premix", nameZh: "喹烯酮预混剂", specs: "10%, 50% | CVP | 25kg/bag" },
    { name: "Colistin Sulfate Premix", nameZh: "硫酸粘菌素预混剂", specs: "10%, 20% | CVP | 25kg/bag" },
    { name: "Tylosin Phosphate Premix", nameZh: "磷酸泰乐菌素预混剂", specs: "10% | CVP | 25kg/bag" },
    { name: "Florfenicol Premix", nameZh: "氟苯尼考预混剂", specs: "10%, 20% | CVP | 25kg/bag" },
    { name: "Enrofloxacin Premix", nameZh: "恩诺沙星预混剂", specs: "10%, 20% | CVP | 25kg/bag" },
    { name: "Tiamulin Fumarate Premix", nameZh: "延胡索酸泰妙菌素预混剂", specs: "10%, 80% | CVP | 25kg/bag" },
    { name: "Tylvalosin Tartrate Premix", nameZh: "酒石酸泰万菌素预混剂", specs: "50% | CVP | 25kg/bag" },
    { name: "Tiamulin Premix", nameZh: "泰妙菌素预混剂", specs: "10%" },
    { name: "Tilmicosin Premix", nameZh: "替米考星预混剂", specs: "20%" },
    { name: "Tylosin Premix", nameZh: "泰乐菌素预混剂", specs: "10%" },
    { name: "Amoxicillin Premix", nameZh: "阿莫西林预混剂", specs: "10%" }
  ],
  coccidiostat: [
    { name: "Maduramycin Ammonium Premix", nameZh: "马杜霉素铵预混剂", specs: "1%, 2%, 5%, 10% | CVP | 25kg/bag" },
    { name: "Maduramycin Ammonium & Nicarbazine Premix", nameZh: "马杜霉素铵和尼卡巴嗪预混剂", specs: "0.75%+8%, 1.5%+16% | CVP | 25kg/bag" },
    { name: "Monensin Sodium Premix", nameZh: "莫能菌素钠预混剂", specs: "20%, 40% | CVP | 25kg/bag" },
    { name: "Monensin Sodium & Nicarbazine Premix", nameZh: "莫能菌素钠和尼卡巴嗪预混剂", specs: "8%+8%, 16%+16% | CVP | 25kg/bag" },
    { name: "Nicarbazine Premix", nameZh: "尼卡巴嗪预混剂", specs: "25% | CVP | 25kg/bag" },
    { name: "Decoquinate Premix", nameZh: "癸氧喹酯预混剂", specs: "6% | CVP | 25kg/bag" },
    { name: "Robenidine Hydrochloride Premix", nameZh: "盐酸氯苯胍预混剂", specs: "6.6%, 10% | CVP | 25kg/bag" },
    { name: "Clopidol Premix", nameZh: "氯羟吡啶预混剂", specs: "25% | CVP | 25kg/bag" },
    { name: "Diclazuril Premix", nameZh: "地克珠利预混剂", specs: "0.5%, 1% | CVP | 25kg/bag" },
    { name: "Dinitolmide Premix", nameZh: "二硝托胺预混剂", specs: "25% | CVP | 25kg/bag" },
    { name: "Salinomycin + Nicarbazine Premix", nameZh: "盐霉素+尼卡巴嗪预混剂", specs: "8%+8%, 12%+6% | 25kg/bag" },
    { name: "Nicarbazin and Ethopabate Premix", nameZh: "尼卡巴嗪和乙氧酰胺苯甲酯预混剂", specs: "25%+1.6% | CVP | 25kg/bag" }
  ],
  api: [
    { name: "Nicarbazine", nameZh: "尼卡巴嗪", specs: "CVP" },
    { name: "Nosiheptide", nameZh: "那西肽", specs: "CVP" },
    { name: "Avilamycin", nameZh: "阿维拉霉素", specs: "IN-HOUSE" },
    { name: "Kitasamycin", nameZh: "北里霉素", specs: "IN-HOUSE" },
    { name: "Maduramycin Ammonium", nameZh: "马杜霉素铵", specs: "CVP" },
    { name: "Monensin Sodium", nameZh: "莫能菌素钠", specs: "CVP" },
    { name: "Decoquinate", nameZh: "癸氧喹酯", specs: "CVP" },
    { name: "Quinocetone", nameZh: "喹烯酮", specs: "CVP" },
    { name: "Sulfadiazine", nameZh: "磺胺嘧啶", specs: "" },
    { name: "Sulfachloropyrazine Sodium", nameZh: "磺胺氯吡嗪钠", specs: "" },
    { name: "Sulfamonomethoxine Sodium", nameZh: "磺胺间甲氧嘧啶钠", specs: "" }
  ],
  binder: [
    { name: "Prit Binder", nameZh: "普瑞特粘合剂", specs: "Modified Cassava Starch Adhesive" }
  ],
  otherPremix: [
    {
      name: "Beta Mineral Pro",
      nameZh: "Beta Mineral Pro 矿物复合预混剂",
      specs: "Trace mineral premix (Cu, Fe, Zn, Mn, I, Se) | 25kg/bag",
      details: {
        summary:
          "Produced by natural copper and zinc mineral materials with ionized purification technology. Supports mineral supplementation, immunity, and growth in animals.",
        summaryZh:
          "采用天然铜、锌矿物原料并经离子提取净化工艺制成，可用于补充矿物元素、增强免疫并促进动物生长。",
        composition: [
          "Copper (Copper hydroxychloride): 522000 mg/kg",
          "Zinc (Zinc hydroxychloride): 27500 mg/kg"
        ],
        compositionZh: [
          "铜（羟氯化铜）：522000 mg/kg",
          "锌（羟氯化锌）：27500 mg/kg"
        ],
        dosage:
          "To make 1 MT of compound feed, use 240-480 g of CZ Grow Fine (equivalent to 125-250 ppm Copper and 6.6-13.2 ppm Zinc).",
        dosageZh:
          "每生产 1 吨配合饲料，添加 240-480 g CZ Grow Fine（相当于铜 125-250 ppm、锌 6.6-13.2 ppm）。",
        uses: [
          "Supply adequate copper and zinc to poultry",
          "Improve poultry performance",
          "Support proper muscle development of birds",
          "Promote stronger immunity",
          "Enhance growth of birds"
        ],
        usesZh: [
          "为家禽补充充足铜和锌",
          "提升家禽生产性能",
          "促进禽类肌肉正常发育",
          "增强机体免疫力",
          "促进禽类生长"
        ],
        shelfLife: "24 months from production date",
        shelfLifeZh: "自生产日期起 24 个月",
        countryOfOrigin: "Made in China",
        countryOfOriginZh: "中国制造",
        precaution:
          "Store in a cool and dry place. Protect from direct sunlight and moisture. Use as early as possible after opening.",
        precautionZh:
          "置于阴凉干燥处保存，避免阳光直射和受潮。开袋后请尽快使用。",
        packaging: "25kg",
        packagingZh: "25kg",
        exporter: {
          name: "TONGDA ENTERPRISES COMPANY LIMITED",
          address: "6/F MANULIFE PLACE 348 KWUN TONG ROAD, KL, HONGKONG.",
          email: "bruce.guo@shmoxisw.com",
          phone: "+86 15821422068",
          website: "https://pritbiotech.com/",
          websiteNote: "(Manufacturing Company)"
        },
        exporterZh: {
          title: "出口方",
          name: "通达企业有限公司",
          address: "香港九龙观塘道348号宏利广场6楼",
          email: "bruce.guo@shmoxisw.com",
          phone: "+86 15821422068",
          website: "https://pritbiotech.com/",
          websiteNote: "（生产公司）"
        }
      }
    }
  ]
};

export const categoryKeys = ["antibiotic", "coccidiostat", "api", "binder", "otherPremix"];

export const categoryIcons = {
  antibiotic: "Pill",
  coccidiostat: "ShieldCheck",
  api: "FlaskConical",
  binder: "Link",
  otherPremix: "Layers"
};
